import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Spinner } from "@/components/ui/spinner";
import { useAuth } from "@/contexts/AuthContext";

export function Home() {
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  console.log("[Home] RENDER", { loading, hasUser: !!user });

  useEffect(() => {
    console.log("[Home] useEffect", { loading, hasUser: !!user });
    if (!loading && user) {
      console.log("[Home] useEffect: navigating to /dashboard");
      navigate("/dashboard", { replace: true });
    }
  }, [user, loading, navigate]);

  if (loading || user) {
    console.log("[Home] showing spinner", { loading, hasUser: !!user });
    return (
      <main className="min-h-dvh flex flex-col items-center justify-center">
        <Spinner className="size-8" />
      </main>
    );
  }

  return (
    <main className="min-h-dvh flex flex-col items-center justify-center px-6 text-center">
      <div className="max-w-5xl w-full space-y-6">
        <div className="inline-flex items-center rounded-full border px-3 py-1 text-xs text-muted-foreground">
          Simple. Fast. Focused.
        </div>
        <h1 className="text-4xl font-bold tracking-tight sm:text-5xl">Todox</h1>
        <p className="text-muted-foreground text-base sm:text-lg">
          A minimal task manager to keep your projects moving. No clutter—just the essentials you
          need to get work done.
        </p>
        <div className="flex items-center justify-center gap-3">
          <Button asChild size="lg">
            <Link to="/register">Get started</Link>
          </Button>
          <Button asChild variant="outline" size="lg">
            <Link to="/login">Sign in</Link>
          </Button>
        </div>

        <Card className="mx-auto max-w-5xl">
          <CardContent className="p-4 grid gap-3 sm:grid-cols-3 text-left">
            <div>
              <div className="text-sm text-muted-foreground">Organize</div>
              <div className="mt-1 font-medium">Projects and tasks</div>
            </div>
            <div>
              <div className="text-sm text-muted-foreground">Collaborate</div>
              <div className="mt-1 font-medium">Invite your team</div>
            </div>
            <div>
              <div className="text-sm text-muted-foreground">Track</div>
              <div className="mt-1 font-medium">Progress in real-time</div>
            </div>
          </CardContent>
        </Card>

        <footer className="text-xs text-muted-foreground">
          © {new Date().getFullYear()} Todox
        </footer>
      </div>
    </main>
  );
}